import React from 'react';
import { usePortfolioContext } from '../contexts/PortfolioContext';
import { useNotificationSettings } from '../hooks/useNotificationSettings';
import LoadingSpinner from '../components/LoadingSpinner';
import PortfolioRequired from '../components/PortfolioRequired';
import NotificationSettingsForm from '../components/NotificationSettingsForm';

const NotificationSettingsPage = () => {
  const { currentPortfolioId } = usePortfolioContext();

  const {
    formData,
    validation,
    loading,
    error,
    updating,
    handleInputChange,
    handleSubmit,
  } = useNotificationSettings({
    portfolioId: currentPortfolioId,
    skip: false,
  });

  if (!currentPortfolioId) {
    return <PortfolioRequired title="Notification Settings" description="Please select a portfolio to configure notification settings." />;
  }

  if (loading) return <LoadingSpinner />;
  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-red-600 mb-4">Error Loading Settings</h2>
          <p className="text-gray-600">{error.message}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white dark:bg-gray-800 shadow rounded-lg">
          {/* Header */}
          <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
            <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
              Notification Settings
            </h1>
            <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
              Configure how you want to receive alerts about your portfolio
            </p>
          </div>

          {/* Form */}
          <div className="px-6 py-6">
            <NotificationSettingsForm
              formData={formData}
              validation={validation}
              updating={updating}
              handleInputChange={handleInputChange}
              handleSubmit={handleSubmit}
              showMoverAlerts={true}
              compact={false}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationSettingsPage;
